
import React from "react";
import { Icon } from "../Icon";

interface SearchInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  autoFocus?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Suchen…",
  className = "",
  style,
  autoFocus,
}) => (
  <div className={"ds-search-input " + className} style={style}>
    <Icon name="search" size={13} />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      autoFocus={autoFocus}
    />
  </div>
);
